// What did Save & Submit actually DO? One place, because three things read the answer.
//
// The server can accept a submit (HTTP 200, ok:true) and still have written NOTHING: an
// item flagged custitem_cannoteditcpq is handed back untouched unless a valid admin
// override rode along. Until 2026-09-02 the component inferred "was this an edit?" as
//
//     const serverEdited = r.item.updated === true || isEdit;
//
// and `isEdit` is computed from configMode BEFORE the request. So a refusal reported as a
// success: the modal said "Item updated on the sales order line", the operator was scored
// for a part nobody changed, and the timing row recorded config_mode "edit". Kevin edited
// HCL-SB26/18-12-3 four times that afternoon on a refused password and had no way to know
// -- the server sent the reason in `overrideRejected` and nothing displayed it.
//
// Kept pure and separate so it can be tested without a browser: npm run test:saveoutcome.
export type SaveOutcomeInput = {
  item?: { updated?: boolean; cannotEdit?: boolean } | null;
  /** Present when a code WAS supplied and rejected -- the server's own reason. */
  overrideRejected?: string;
};

export type SaveOutcome = {
  /** The server wrote to an existing item. Drives the modal copy, the points call and the
   *  timing row's config_mode -- never `isEdit` on its own. */
  edited: boolean;
  /** The server refused the write: locked item, no valid override. Nothing was changed. */
  refusedByLock: boolean;
  /** What to tell the operator. Null unless refused. */
  refusalReason: string | null;
};

export function describeSaveOutcome(r: SaveOutcomeInput, isEdit: boolean): SaveOutcome {
  const refusedByLock = r?.item?.cannotEdit === true;
  return {
    // A refusal is never an edit, whatever the pre-request mode believed.
    edited: !refusedByLock && (r?.item?.updated === true || isEdit),
    refusedByLock,
    refusalReason: !refusedByLock
      ? null
      : r?.overrideRejected
        // A WRONG password names itself. Anything else sends someone hunting for the
        // wrong problem -- which is precisely what happened on 2026-09-02.
        ? `That password was refused (${r.overrideRejected}). Nothing was changed.`
        : "This item is locked to CPQ edits and nothing was changed. Turn on Administrator " +
          "mode with the password to edit it in place, or save it as a new part.",
  };
}
